/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest =
  {
    ledgerCanisterId: string;
    index: number;
  };

/** @internal */
export const GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$inboundSchema:
  z.ZodType<
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    index: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
    });
  });

/** @internal */
export type GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$Outbound =
  {
    ledger_canister_id: string;
    index: number;
  };

/** @internal */
export const GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$outboundSchema:
  z.ZodType<
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$Outbound,
    z.ZodTypeDef,
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    index: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$ {
  /** @deprecated use `GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$inboundSchema;
  /** @deprecated use `GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$outboundSchema;
  /** @deprecated use `GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$Outbound` instead. */
  export type Outbound =
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$Outbound;
}

export function getTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequestToJSON(
  getTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest:
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest,
): string {
  return JSON.stringify(
    GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$outboundSchema
      .parse(
        getTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest,
      ),
  );
}

export function getTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetTansactionApiV1LedgersLedgerCanisterIdTransactionsIndexGetRequest' from JSON`,
  );
}
